export default {
  message: {
    switchLanguage: 'Switch Language',
    common: {
      today: "今天",
      // 基础操作
      add: "添加",
      edit: "编辑",
      delete: "删除",
      batchDelete: "批量删除",
      save: "保存",
      cancel: "取消",
      confirm: "确认",
      search: "搜索",
      reset: "重置",
      remove: "下架",
      view: "查看",
      logs: "日志",
      selectAll: "全选",
      operation: "操作",
      // 状态
      status: "状态",
      statusMap: {
        "PUBLISH": "出售中",
        "UN_PUBLISH": "已下架",
        "SOLD": "已售卖"
      },
      // 查询状态
      queryStatus: "查询状态",
      queryStatusMap: {
        "1": "待完成",
        "2": "完成",
        "-1": "驳回"
      },
      // 分类
      category: "分类",
      categoryMap: {
        GOOGLE_PLAY: "Google Play",
        IOS: "iOS",
        ADSENSE: "Adsense",
        ADMOB: "AdMob",
        HUAWEI: "Huawei",
        APPLOVIN: "Applovin",
        MINTEGRAL: "Mintegral",
        META: "Meta",
        IRON_SOURCE: "Iron source",
        UNITY: "Unity",
        CHARTBOOST: "Chartboost",
        INMOBI: "InMobi",
        DIGITAL_TURBINE: "Digital Turbine",
      },
      // 时间
      createTime: "创建时间",
      publishTime: "发布时间",
      // 验证
      validEmail: "验证邮箱",
      validPhone: "验证电话",
      // 文件
      image: "图片",
      upload: "点击上传",
      download: "一键下载",
      // 其他
      keywords: "关键词",
      name: "名称",
      phone: "电话",
      developerEmail: "开发者邮箱",
      content: "内容",
      tips: "提示",
      success: "成功",
      error: "错误",
      confirmDelete: "确定删除？",
      copySuccess: "复制成功",
      createBy: "创建人",
      viewCount: "查看数",
      // 验证消息
      valid: {
        selectData: "请选择数据",
      }
    },
    api: {
      "logout": "登出",
      "logoutTitle": "你已经退出<br/>请重新登录",
      "reLogin": "重新登录",
      "0000": "系统异常",
      "0001": "登陆过期请重新登陆",
      "0010": "参数错误",
      "0101": "验证码错误",
      "0102": "用户名或密码错误",
      "0103": "账户不可用",
      "0104": "数据不存在",
      "0105": "管理员账户不允许删除",
      "0106": "角色已存在",
      "0107": "管理员角色不允许删除",
      "0108": "账号已存在",
      "0109": "用户名已存在",
      "0110": "无法找到用户",
      "0111": "原密码不正确",
      "0112": "手机号码已存在",
      "0113": "手机号不存在",
      "0114": "手机号为空",
      "0115": "无法找到账号信息",
      "0116": "验证邮箱域名错误",
      "0117": "标记成交时成交价格不能为空",
      "0118": "无台账权限",
    },
    login: {
      welcome: 'Hi,欢迎使用51gp',
      title: "登录账户",
      username: "用户名",
      password: "密码",
      validCode: "验证码",
      btn: "登录",
      copyright: "版权所有：51gp",
      rule: {
        passwordLess: "密码不能小于6位数",
        usernameRequired: "请输入用户",
        validRequired: "请输入验证码",
      }
    },
    source: {
      module: "供应商",
      parseStatusLabel: "解析状态",
      parseStatus: {
        "0": "未入库",
        "1": "已入库",
        "2": "重复",
        "3": "信息不全",
        "4": "解析错误",
      },
      valid: {
        selectData: "请选择数据",
        content: "请输入账号信息",
        name: "请输入名称",
        phone: "请输入电话",
        developerEmail: "请输入开发者邮箱",
        category: "请选择账号分类（必选）",
        developerEmailFormat: "开发者邮箱格式不正确",
        images: "请添加图片"
      },
      parseErrorMsgs: {
        "ERROR_CATEGORY_REQUIRED": "请由供应商选择账号分类",
        "ERROR_COUNTRY_EMPTY": "国家为空",
        "ERROR_PKG_URL_EMPTY": "GP 链接为空",
        "ERROR_PURCHASE_PRICE_EMPTY": "采购价格为空",
        "ERROR_SOLD": "已售出",
        "ERROR_REPEAT": "重复",
        "ERROR_ALIYUN_CALL_ERROR": "阿里云调用错误"
      },
      accountRepeated: "账号重复",
      summary: {
        waitComplete: "待完成",
        completed: "已完成",
        reject: "驳回",
        soldMissingBuy: "待补买入价",
        monthTransactionCount: "本月交易数",
      },
      missingBuyTag: "待补买入价",
      reject: "驳回",
      editTip: "以下信息不全，请在下方补齐后保存",
      supplementTitle: "补齐账号字段（按需填写，保存后自动重新解析）",
      supplementRequired: "账号信息",
      supplementRequiredHint: "国家 / 价格 / GP链接等",
      accountFields: "账号信息",
      supplementAppCounts: "APP 数量",
      supplementTags: "账号标签",
      supplementSupplier: "供应商信息",
      contentHint: "原始粘贴文本，可展开修改",
      pkgUrlsPlaceholder: "粘贴 Google Play 应用链接，多个用换行分隔"
    },
    accountInfo: {
      module: "开发者账号",
      moreSearch: "更多搜索条件",
      registerTime: "时间",
      country: "国家",
      appCount: "APP",
      unPubAppCount: "未发布",
      pauseCount: "暂停",
      rejectCount: "拒绝",
      deleteCount: "删除",
      draftCount: "草稿",
      transferCount: "转移",
      sourceCode: "有源码",
      secretKey: "有密匙",
      language: "语言",
      admob: "Admob",
      org: "企业账号",
      highDownload: "高下载",
      paymentInfo: "创建支付",
      access: "访问",
      verify: "已验证",
      purchasePrice: "采购价格",
      sellingPrice: "销售价格",
      dealPrice: "成交价格",
      buyPrice: "买入价格",
      pkgUrls: "GP地址",
      index: "序号",
      url: "链接",
      cancelView: "取消查看",
      sourceId: "采购ID",
      source: "账号信息",
      sourceName: "供应商名称",
      sourcePhone: "供应商电话",
      developerEmail: "开发者邮箱",
      recoveryEmail: "恢复邮箱",
      recoveryPhone: "恢复电话",
      repeated: "重复",
      year: "年份",
      repeatInfo: "重复信息",
      repeatType: "类型",
      repeatTypes: {
        "1": "当日重复",
        "2": "历史重复"
      },
      affiliateUserName: "交易员",
      buyerUserName: "购买者",
      soldTime: "售卖时间",
      more: "更多",
      valid: {
        selectData: "请选择数据",
        sourceId: "请输入采购ID",
        registerTime: "请选择时间",
        country: "请选择国家",
        purchasePrice: "请输入采购价格",
        sellingPrice: "请输入售卖价格",
        dealPrice: "请输入成交价格",
        soldTime: "请选择售卖时间",
        buyPrice: "请输入买入价格",
        developerEmail: "请输入开发者邮箱",
        url: "请填入URL",
        pkgUrls: "请添加链接",
      },
      type: "类型",
      types: {
        game: "游戏",
        tool: "工具",
        info: "资讯",
      },
      expandSearch: "展开搜索",
      collapseSearch: "折叠搜索",
      apple: "iOS",
      createByName: "创建人",
      accountQuality: "账号质量",
      accountQualityMap: {
        "high": "优质",
        "normal": "普通",
        "risk": "风险"
      },
      sectionSource: "供应商信息",
      sectionBasic: "基本信息",
      sectionAttrs: "账号属性",
      sectionPrice: "价格与交易",
      sectionContact: "联系验证",
      sectionMedia: "应用与附件",
      queryStatusAction: "发起查询",
      queryStatusCancelAction: "取消查询",
      summary: {
        waitComplete: "待完成",
        completed: "已完成",
        reject: "驳回",
        todayNewAdd: "今日新增",
        todayRepeat: "今日重复",
        myQuery: "我的查询",
        missingDeal: "待补成交价",
        missingBuy: "待补买入价",
        monthTransactionCount: "本月交易数",
      }
    },
    emailTemplate: {
      module: "邮件发送模板",
    },
    ledger: {
      module: "成交台账",
      dateRange: "成交日期",
      count: "成交笔数",
      dealAmount: "成交额",
      buyAmount: "买入额",
      profit: "毛利",
      missingBuyCount: "待补买入价",
      missingDealCount: "待补成交价",
      chartTitle: "每日成交曲线",
      listTitle: "成交流水",
      dealPrice: "成交金额",
      buyPrice: "买入价格",
      missingBuy: "待补买入价",
      missingDeal: "待补成交价",
      add: "+ 新增数据",
      edit: "修改成交",
      buyer: "购买者",
      staff: "交易员",
      buyerPlaceholder: "可输入或选择购买者",
      staffPlaceholder: "可输入或选择交易员",
      validEmail: "恢复邮箱",
      validPhone: "恢复电话",
      accountInfo: "账号信息",
      viewInfo: "查看信息",
      extraCost: "额外成本",
      extraCostPlaceholder: "如：号码, VPS",
      paymentCurrency: "支付币种",
      none: "无",
      sectionDeal: "成交信息",
      sectionAccount: "账号信息",
      sectionContact: "联系与协作",
      paymentCurrencyOptions: {
        private: "人民币-对私",
        qrcode: "人民币-扫码"
      },
      valid: {
        dealPrice: "请输入成交金额",
        soldTime: "请选择成交日期",
        category: "请选择账号类型"
      }
    },
    sys: {
      module: "系统",
      admin: {
        module: "系统",
        search: "搜索",
        operation: "操作",
        roleList: "角色列表",
        roleName: "角色名称",
        dataPermission: "数据权限",
        permissionEditor: {
          priceOverview: "角色与价格总览",
          overviewHint: "金额单位为人民币，点击角色配置权限和价格规则。AppLovin 一列为额外采购加价。",
          readOnly: "只读",
          purchaseAdjustment: "基础采购浮动",
          sellingAdjustment: "基础售卖浮动",
          purchaseColumn: "采购浮动",
          sellingColumn: "售卖浮动",
          rawRoleHint: "管理员和供应商不应用 AppLovin 额外加价，基础浮动仍按原规则计算。",
          notApplied: "不适用",
          newRole: "新建角色",
          priceRules: "价格规则",
          applovinExtra: "AppLovin 额外采购加价",
          priceRuleHint: "基础浮动在账号解析时记录；AppLovin 额外加价按当前角色配置生效，不修改供应商原价。",
          preview: "采购价示例",
          supplierPrice: "试算采购原价",
          sellingPreview: "售卖价示例",
          sellingBasePrice: "试算售卖原价",
          sellingResult: "浮动后售卖价（所有分类）",
          sellingPreviewHint: "售卖原价 + 基础售卖浮动，负数表示减价；AppLovin 额外加价仅影响采购价。",
          sellingHidden: "此角色未开启实际账号的售卖价查看权限；上方仍展示试算结果。",
          otherCategory: "其他分类",
          previewHint: "两项试算原价独立计算，仅用于预览，不保存，不影响实际账号价格。示例按此处的采购、售卖浮动分别计算；历史账号仍保留解析时的基础浮动。原价为零时不应用浮动。",
          purchaseHidden: "此角色未开启实际账号的采购价查看权限；上方仍展示试算结果。",
          permissionSettings: "权限设置",
          permissionHint: "关闭查看会取消该字段的编辑与隐藏设置。「列表隐藏数值」只隐藏列表中的数值。",
          searchFields: "搜索字段名称",
          categoryLocked: "上传时必须手动选择分类；后续能否修改，由对应模块的分类「可编辑」权限控制，创建人也不能绕过。",
          visibleFields: "项字段可查看",
          clearFields: "取消全部字段查看",
          selectFields: "查看全部字段",
          fieldName: "字段名称",
          view: "可查看",
          hideListValue: "列表隐藏数值",
          locked: "已锁定",
          noMatchingFields: "没有匹配的字段",
          clearOperations: "取消全部操作",
          selectOperations: "允许全部操作",
          readOnlyHint: "系统管理员角色仅供查看。",
          saveHint: "保存后生效。",
          saveRole: "保存角色",
        },
        applovinFloatLabel: "AppLovin额外采购加价(¥)",
        floatLabel: "浮动",
        permHint: "勾选左侧模块以展开字段与操作权限配置",
        edit: "编辑",
        cancelEdit: "取消编辑",
        delete: "删除",
        add: "添加",
        username: "用户名",
        password: "密码",
        confirmPassword: "确认密码",
        name: "名字",
        phone: "电话号码",
        email: "邮箱",
        role: "角色",
        cancel: "取消",
        confirm: "确认",
        addOrEdit: "添加或删除用户",
        createTime: "创建时间",
        tips: "提示",
        success: "成功",
        view: "查看",
        cancelView: "取消查看",
        confirmDelete: "确定删除？",
        checkAll: "全选",
        columns: "字段",
        editable: "可编辑",
        viewable: "可查看",
        noData: "不显示",
        updatePassword: "修改密码",
        logout: "退出",
        originPassword: "原密码",
        newPassword: "新密码",
        accountInfoStatusMap: {
          "PUBLISH": "出售中",
          "UN_PUBLISH": "已下架",
          "SOLD": "已售卖"
        },
        status: "状态",
        parentName: "创建人",
        workStatus: "合作状态",
        affiliate: "分销商统计",
        userName: "用户名",
        month: "月份",
        day: "日期",
        count: "数量",
        onlineTime: "在线时间",
        totalLoginCount: "总登录次数",
        todayLoginCount: "当天登录次数",
        loginLog: "登录日志",
        loginIp: "登录IP",
        loginCountry: "登录国家",
        loginCity: "登录城市",
        summary: "统计",
        more: "更多",
        childAdminSummary: "子管理员统计",
        supplierUpload: "供应商上传",
        uploadCount: "上传数量",
        supplierParent: "上级",
        addUserCount: "客户数量",
        addAccountCount: "账户数量",
        addSubAccountCount: "账户数量(子账号)",
        valid: {
          emailIncorrect: "请输入正确的邮箱",
          emailRequire: "请输入邮箱",
          phone: "请输入电话号码",
          username: "请输入用户名",
          password: "请输入密码",
          roleName: "请输入角色名",
          permission: "请选择权限",
          usernameExists: "用户名已存在",
          role: "请输入角色",
          passwordRepeat: "确认密码不一致"
        },
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/admin/i18n/zh.js